<p-dialog
  header="{{ dialog_title }}"
  [modal]="true"
  [closeOnEscape]="false"
  [resizable]="true"
  [closable]="true"
  [dismissableMask]="true"
  [style]="{ width: '40rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [(visible)]="premiumVisible"
  (onHide)="closeDialog()">
  @if (premiumVisible && dialog_data) {
    @if (dialog_main_title) {
      <div>
        {{ dialog_main_title }}
      </div>
    }

    @if (dialog_main_desc) {
      <div>
        {{ dialog_main_desc }}
      </div>
    }

    <div class="flex justify-between mt-4">
      <p-button
        label="{{ 'Subscription upgrade' | translate }}"
        [rounded]="true"
        (click)="openPremium()" />
    </div>
  }
</p-dialog>
